import styled from 'styled-components';

const CircleButtonWithArrow = styled.div`
    cursor: pointer;
    transition: opacity .35s ease-out;

    width: 32px;
    height: 32px;
    border-radius: 100%;
    
    background-color: #FFF;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);
    
    &::after {
        content: '';
        position: absolute;
        
        top: 12px;
        left: ${({ isArrowRight }) => (isArrowRight ? 11 : 13)}px;
        width: 7px;
        height: 7px;
        
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        
        transform: rotate(${({ isArrowRight }) => (isArrowRight ? 45 : -135)}deg);
    }

    :hover :after {
        border-top: 1px solid #002679;
        border-right: 1px solid #002679;
    }

    :active :after {
        border-top: 1px solid #002679;
        border-right: 1px solid #002679;
    }

    :hover {
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
    }

    :active {
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
    }
`;

export default CircleButtonWithArrow;
